import { createState, useState } from '@hookstate/core';
const initialState = {
    open: false,
    modules: [],
};

const moduleDrawerState = createState(initialState);

export const setDrawerOpen = (props) => {
    if (props && props.length > 0) {
        moduleDrawerState.set({
            ...initialState,
            open: true,
            modules: props,
        });
    }
    return;
};
export const useModuleDrawerState = () => {
    return useState(moduleDrawerState);
};
export const handleDrawerClose = () => {
    moduleDrawerState.set(initialState);
};
